import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'match-card',
    templateUrl: './match-card.component.html',
    imports: [
        MatCardModule,
    ],
    styleUrls: ['./match-card.component.less'],
})

class MatchCardComponent {
    @Input() title: string;

    @Input() author: string;

    @Input() number: number;

    @Input() borderStyle = false;
}

export default MatchCardComponent;
